// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__Rxh4x","info":"styles_info__D3ZQM"};
module.exports.__checksum = "6c2d6250bee1"